export const DEFAULT_PAGE_SIZE = 100;

export const COLUMN_TO_SORT_BY = {
  updateOn: "UpdatedDate",
  createOn: "CreatedDate",
  referenceID: "RequestId",
  applicantFullName: "ApplicantName",
  requestConfirmTitle: "RequestStatus",
};

export const SORT_BY_TO_COLUMN = Object.entries(COLUMN_TO_SORT_BY).reduce(
  (acc, [column, sortBy]) => {
    acc[sortBy] = column;
    return acc;
  },
  {}
);

export const DEFAULT_SORT_BY = "UpdatedDate";
export const DEFAULT_SORT_DIRECTION = "desc";

export const sortByToColumnId = (sortBy) =>
  SORT_BY_TO_COLUMN[sortBy] || "updateOn";

export const columnIdToSortBy = (columnId) =>
  COLUMN_TO_SORT_BY[columnId] || DEFAULT_SORT_BY;

export const parseAllRequestPagedResponse = (res) => {
  const pick = (obj, ...keys) => {
    if (!obj) return undefined;
    for (const key of keys) {
      if (obj[key] !== undefined && obj[key] !== null) return obj[key];
    }
    return undefined;
  };

  // ApiResult → PagedResultDto؛ یا آرایهٔ قدیمی (fallback)
  const outer = res?.data ?? res ?? {};
  const payload = Array.isArray(outer)
    ? { items: outer, totalCount: outer.length }
    : outer?.data && !Array.isArray(outer.data) && (outer.data.items || outer.data.Items)
      ? outer.data
      : Array.isArray(outer?.data)
        ? { items: outer.data, totalCount: outer.data.length }
        : outer?.items || outer?.Items
          ? outer
          : outer?.data ?? outer;

  const items = pick(payload, "items", "Items") ?? [];
  const list = Array.isArray(items) ? items : [];

  return {
    items: list,
    totalCount: Number(pick(payload, "totalCount", "TotalCount") ?? list.length),
    pageNumber: Number(pick(payload, "pageNumber", "PageNumber") ?? 1),
    pageSize: Number(pick(payload, "pageSize", "PageSize") ?? DEFAULT_PAGE_SIZE),
    totalPages: Number(pick(payload, "totalPages", "TotalPages") ?? 0),
    hasPreviousPage: Boolean(pick(payload, "hasPreviousPage", "HasPreviousPage")),
    hasNextPage: Boolean(pick(payload, "hasNextPage", "HasNextPage")),
  };
};
